require('jquery');
require('bootstrap');
require('./angular-main.js');
require('./polyfil.js');
require('script-loader!../lib/kendo/kendo.core.min.js');
require('script-loader!../lib/kendo/kendo.angular.min.js');
require('script-loader!../lib/kendo/kendo.popup.min.js');
require('script-loader!../lib/kendo/kendo.notification.min.js');
require('script-loader!../lib/kendo/kendo.fx.min.js');
require('script-loader!../lib/kendo/kendo.tooltip.min.js');
require('script-loader!../lib/kendo/kendo.menu.min.js');
require('script-loader!../lib/kendo/kendo.userevents.min.js');
require('script-loader!../lib/kendo/kendo.draganddrop.min.js');
require('script-loader!../lib/kendo/kendo.window.min.js');
require('script-loader!../extensions/window.js');
require('script-loader!../lib/kendo/kendo.validator.min.js');
require('script-loader!../lib/kendo/kendo.data.min.js');
require('script-loader!../lib/kendo/kendo.list.min.js');
require('script-loader!../lib/kendo/kendo.dropdownlist.min.js');
require('script-loader!../lib/kendo/kendo.combobox.min.js');
require('script-loader!../lib/kendo/kendo.virtuallist.min.js');
require('script-loader!../lib/kendo/kendo.autocomplete.min.js');
require('./interceptors/session-expired-interceptor.js');
require('./interceptors/response-error-interceptor.js');
require('./services/common-service.js');
require('./services/notification-service.js');
require('./services/url-service.js');
require('./services/org-settings-service');
require('./services/password-service.js');
require('./services/basket-service.js');
require('./services/formatting-service.js');
require('./directives/basket/quick-add-directive.js');
require('./services/auth-service.js');
require('./directives/session-expired-directive.js');


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/js/main/common-entry.js
// module id = 476
// module chunks = 37